import { useRef, useState } from "react";
import { BACKEND_URL } from "../config/api";
import "../styles/DanePage.css";

export default function DanePage({ authToken }) {
  const fileInputRef = useRef(null);
  const [exportState, setExportState] = useState({ loading: false, error: "" });
  const [importState, setImportState] = useState({ loading: false, error: "", success: "" });

  async function handleExport() {
    setExportState({ loading: true, error: "" });
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/export-db`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.message ?? "Błąd eksportu.");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "db_meble_images.xlsx";
      a.click();
      URL.revokeObjectURL(url);
      setExportState({ loading: false, error: "" });
    } catch (error) {
      setExportState({ loading: false, error: error.message });
    }
  }

  async function handleImport(event) {
    const file = event.target.files?.[0];
    if (!fileInputRef.current) return;
    fileInputRef.current.value = "";

    if (!file) return;

    setImportState({ loading: true, error: "", success: "" });
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(`${BACKEND_URL}/api/admin/import-db`, {
        method: "POST",
        headers: { Authorization: `Bearer ${authToken}` },
        body: formData,
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.message ?? "Błąd importu.");
      }

      setImportState({ loading: false, error: "", success: data.message });
    } catch (error) {
      setImportState({ loading: false, error: error.message, success: "" });
    }
  }

  return (
    <section className="dane-page">
      <div className="dane-page__card">
        <div className="dane-page__header">
          <h1>Dane</h1>
          <p>Eksport i import bazy danych</p>
        </div>

        <div className="dane-page__section">
          <p className="dane-page__section-title">Eksport</p>
          <div className="dane-page__row">
            <button
              className="dane-page__action"
              type="button"
              disabled={exportState.loading}
              onClick={handleExport}
            >
              {exportState.loading ? "Pobieranie..." : "Pobierz bazę"}
            </button>
            {exportState.error && (
              <p className="dane-page__message dane-page__message--error">{exportState.error}</p>
            )}
          </div>
        </div>

        <hr className="dane-page__divider" />

        <div className="dane-page__section">
          <p className="dane-page__section-title">Import</p>
          <div className="dane-page__row">
            <button
              className="dane-page__secondary-action"
              type="button"
              disabled={importState.loading}
              onClick={() => fileInputRef.current?.click()}
            >
              {importState.loading ? "Wgrywanie..." : "Wgraj bazę"}
            </button>
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx"
              style={{ display: "none" }}
              onChange={handleImport}
            />
            {importState.error && (
              <p className="dane-page__message dane-page__message--error">{importState.error}</p>
            )}
            {importState.success && (
              <p className="dane-page__message dane-page__message--success">{importState.success}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
